/**
 * Created by mdemkin on 07.07.17.
 */



// WEBPACK FOOTER //
// ./src/store/getters.js